import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { PlatformProvider } from './contexts/PlatformContext';
import { ChooseProfile } from './pages/ChooseProfile';
import { Confirmed } from './pages/Confirmed';
import { Login } from './pages/Login';
import { OrderDetail } from './pages/OrderDetail';
import { Orders } from './pages/Orders';
import { Plan } from './pages/Plan';
import { Profile } from './pages/Profile';
import { Results } from './pages/Results';
import { Review } from './pages/Review';
export function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return <div className="dark min-h-screen w-full bg-[#0f1017] font-heading text-foreground antialiased" data-id="element-0" data-mp="2wj8cxn0bok3n">
      <BrowserRouter data-id="element-1" data-mp="28t4lsf4bmctj">
        <PlatformProvider data-id="element-2" data-mp="28sl5t3y8dyi5">
          <Routes data-id="element-3" data-mp="23vci6nubd29i">
            <Route path="/" element={<Login data-id="element-5" data-mp="23ujk0b9f7l2z" />} data-id="element-4" data-mp="23vupcfiil0w7" />
            <Route path="/choose-profile" element={<ChooseProfile data-id="element-7" data-mp="3ik7e6ay3c1o0" />} data-id="element-6" data-mp="23v2uj6wqr76z" />
            <Route element={<AppShell data-id="element-9" data-mp="3ijfunyhrpue3" />} data-id="element-8" data-mp="3ij64oawq3n8e">
              <Route path="/profile" element={<Profile data-id="element-11" data-mp="3ml17xky7saot" />} data-id="element-10" data-mp="3ii4qvyobommz" />
              <Route path="/results" element={<Results data-id="element-13" data-mp="3mj6ibtbzzuee" />} data-id="element-12" data-mp="3mk83iqmq9x9u" />
              <Route path="/plan" element={<Plan data-id="element-15" data-mp="3rdatypw7kqlt" />} data-id="element-14" data-mp="3rbr9en3irte8" />
              <Route path="/review" element={<Review data-id="element-17" data-mp="5yhgo69t1c8" />} data-id="element-16" data-mp="3rd191gq0t9mz" />
              <Route path="/confirmed" element={<Confirmed data-id="element-19" data-mp="56nfhsbnbo2" />} data-id="element-18" data-mp="6801qozk67w" />
              <Route path="/orders" element={<Orders data-id="element-21" data-mp="2zlv6yuqqp1v2" />} data-id="element-20" data-mp="2zl3alhpbj03q" />
              <Route path="/orders/:orderId" element={<OrderDetail data-id="element-23" data-mp="33mov9p83gioh" />} data-id="element-22" data-mp="2zmo3z3zwcd00" />
            </Route>
            <Route path="*" element={<Navigate to="/" replace data-id="element-25" data-mp="33ori60dy9voz" />} data-id="element-24" data-mp="33nggq77z9011" />
          </Routes>
        </PlatformProvider>
      </BrowserRouter>
    </div>;
}